

import React from "react";

export const Dumbbell = ({ className }) => {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_69_809)" opacity="0.5">
        <path
          d="M9.60114 9.60001L6.40114 6.40002M14.3345 14.3333L13.4011 13.4M2.60114 2.60001L1.66781 1.66668M12.4391 14.3233C12.1891 14.5734 11.85 14.714 11.4964 14.714C11.1427 14.7141 10.8036 14.5737 10.5535 14.3237C10.3034 14.0737 10.1628 13.7345 10.1628 13.3809C10.1627 13.0273 10.3031 12.6881 10.5531 12.438L9.37514 13.6167C9.12504 13.8668 8.78584 14.0073 8.43214 14.0073C8.07845 14.0073 7.73924 13.8668 7.48914 13.6167C7.23905 13.3666 7.09854 13.0274 7.09854 12.6737C7.09854 12.32 7.23905 11.9808 7.48914 11.7307L11.7318 7.48802C11.9819 7.23792 12.3211 7.09741 12.6748 7.09741C13.0285 7.09741 13.3677 7.23792 13.6178 7.48802C13.8679 7.73811 14.0084 8.07732 14.0084 8.43101C14.0084 8.78471 13.8679 9.12392 13.6178 9.37401L12.4391 10.552C12.6892 10.302 13.0284 10.1616 13.382 10.1616C13.7357 10.1617 14.0748 10.3022 14.3248 10.5523C14.5748 10.8024 14.7152 11.1416 14.7152 11.4953C14.7151 11.8489 14.5746 12.188 14.3245 12.438L12.4391 14.3233ZM4.27048 8.51201C4.02038 8.76211 3.68117 8.90262 3.32748 8.90262C2.97378 8.90262 2.63458 8.76211 2.38448 8.51201C2.13438 8.26192 1.99387 7.92271 1.99387 7.56902C1.99387 7.21532 2.13438 6.87611 2.38448 6.62601L3.56314 5.44801C3.43931 5.57181 3.2923 5.67 3.13052 5.73698C2.96873 5.80396 2.79534 5.83841 2.62024 5.83838C2.26661 5.83832 1.92749 5.69778 1.67748 5.44768C1.55368 5.32385 1.4555 5.17684 1.38852 5.01505C1.32154 4.85327 1.28708 4.67988 1.28711 4.50478C1.28717 4.15115 1.42771 3.81203 1.67781 3.56201L3.56314 1.67668C3.81315 1.42658 4.15228 1.28604 4.50591 1.28598C4.68101 1.28595 4.8544 1.32041 5.01618 1.38739C5.17797 1.45437 5.32497 1.55256 5.44881 1.67635C5.57265 1.80014 5.67089 1.94711 5.73792 2.10887C5.80496 2.27063 5.83948 2.44401 5.83951 2.61911C5.83954 2.79421 5.80508 2.9676 5.73811 3.12939C5.67113 3.29117 5.57294 3.43818 5.44914 3.56201L6.62714 2.38335C6.87724 2.13325 7.21645 1.99274 7.57014 1.99274C7.92384 1.99274 8.26304 2.13325 8.51314 2.38335C8.76324 2.63345 8.90375 2.97265 8.90375 3.32635C8.90375 3.68004 8.76324 4.01925 8.51314 4.26935L4.27048 8.51201Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.33333"
        />
      </g>

      <defs>
        <clipPath id="clip0_69_809">
          <rect fill="white" height="16" width="16" />
        </clipPath>
      </defs>
    </svg>
  );
};
